import isEmail from 'validator/lib/isEmail';
import isEmpty from 'validator/lib/isEmpty';

const required = str => !isEmpty(str);

export default {
	validators: {
		email: { required, isEmail },
		password: { required }
	},
	messages: {
		email:{
			required: 'login_email_required',
			isEmail: 'login_email_invalid'
		},
		password: {
			required: 'login_password_required'
		}
	}
}